/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassstudentClassstudentidChannelsChannelid200,
  GetApiV1ClassstudentClassstudentidChannelsChannelid401,
  GetApiV1ClassstudentClassstudentidChannelsChannelid404,
  GetApiV1ClassstudentClassstudentidChannelsChannelid500,
  GetApiV1ClassstudentClassstudentidChannelsChannelidPathParams,
  GetApiV1ClassstudentClassstudentidChannelsChannelidQueryResponse,
} from "../../types/classStudentChannelsController/GetApiV1ClassstudentClassstudentidChannelsChannelid.ts";
import { channelDetailViewModelSchema } from "../channelDetailViewModelSchema.ts";

export const getApiV1ClassstudentClassstudentidChannelsChannelidPathParamsSchema =
  z.object({
    classStudentId: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsChannelidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassstudentClassstudentidChannelsChannelid200Schema =
  z.lazy(
    () => channelDetailViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsChannelid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassstudentClassstudentidChannelsChannelid401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassstudentClassstudentidChannelsChannelid404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsChannelid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassstudentClassstudentidChannelsChannelid500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsChannelid500>;

export const getApiV1ClassstudentClassstudentidChannelsChannelidQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassstudentClassstudentidChannelsChannelid200Schema,
  ) as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsChannelidQueryResponse>;
